import { trigger } from "@/services/utils";

const name = "mask";

const mask = (value, mask) => {
  // eslint-disable-next-line no-param-reassign
  value = value.toString();
  const positions = [];
  for (const c in mask) {
    if (mask[c] != "#") {
      positions.push({
        character: mask[c],
        position: c
      });
    }
  }

  let count = 0;
  let stringReturn = "";
  for (const string in mask) {
    if (mask[string] == "#") {
      if (value[count]) {
        stringReturn += value[count];
        count++;
      }
    } else {
      positions.forEach(value => {
        if (value.position == stringReturn.length) {
          stringReturn += value.character;
        }
      });
    }
  }

  return stringReturn;
};

const directive = {
  update: (el, binding, vnode, oldVnode) => {
    const vnodeValue = vnode.data.domProps.value
      ? vnode.data.domProps.value.length
      : "";
    const vnodeOldValue = oldVnode.data.domProps.value
      ? oldVnode.data.domProps.value.length
      : "";
    if (!(vnodeValue < vnodeOldValue)) {
      const maskValue = binding.value;
      let { value } = el;
      if (maskValue) {
        if (value != "") {
          value = value.replace(/[^\d]+/g, "");
          if (value != "") {
            value = value.substring(0, maskValue.length);
            el.value = mask(value, maskValue);
          } else el.value = "";
          trigger(el, "input");
        }
      }
    }
  }
};

const params = {
  directive,
  name
};

export default params;
